import React from 'react';

export type DashboardView = 'grid' | 'compact';

interface DashboardViewSelectorProps {
    currentView: DashboardView;
    onViewChange: (view: DashboardView) => void;
}

const DashboardViewSelector: React.FC<DashboardViewSelectorProps> = ({ currentView, onViewChange }) => {
    return (
        <div className="flex items-center space-x-2 bg-white rounded-lg shadow-sm border border-gray-200 p-2 mb-4 ml-auto w-fit">
            <span className="text-xs font-medium text-gray-600">Layout:</span>
            <div className="flex items-center space-x-1">
                <span className={`text-xs font-medium transition-colors ${currentView === 'grid' ? 'text-blue-600' : 'text-gray-500'}`}>
                    Grid
                </span>
                <button
                    onClick={() => onViewChange(currentView === 'grid' ? 'compact' : 'grid')}
                    className={`relative inline-flex h-4 w-7 items-center rounded-full transition-colors focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 ${
                        currentView === 'grid' ? 'bg-blue-600' : 'bg-gray-300'
                    }`}
                    aria-label="Toggle layout view"
                >
                    <span
                        className={`inline-block h-2.5 w-2.5 transform rounded-full bg-white transition-transform ${
                            currentView === 'grid' ? 'translate-x-3.5' : 'translate-x-0.5'
                        }`}
                    />
                </button>
                <span className={`text-xs font-medium transition-colors ${currentView === 'compact' ? 'text-blue-600' : 'text-gray-500'}`}>
                    Compact
                </span>
            </div>
        </div>
    );
};

export default DashboardViewSelector;